import {PropsWithChildren, MouseEvent} from 'react'
import {BaseComponent, BaseProps, BaseState} from '../BaseComponent'

export interface ButtonProps extends BaseProps {
    type: 'button'
    isActive?: boolean
    updateActiveButton?: Function
}

interface ButtonState extends BaseState {
    isActive: boolean
}

/**
 * gli attributi sicuramente gestiti -- quelli da non riscrivere
 */
const defaults : ButtonProps = {
    id: undefined,
    className: 'btn btn-primary',
    type: 'button',
    isActive: false,
    onClick: undefined,
    updateActiveButton: undefined
}


class Button extends BaseComponent<PropsWithChildren<ButtonProps>, ButtonState> {

    constructor (props: any) {
        super(props)

        this.mergedProps = { ...defaults, ...props} as ButtonProps

        this.state = {
            isActive: this.mergedProps.isActive ?? false
        }

        this.onCLickHandler = this.onCLickHandler.bind(this)
    }

    render() {
        const classString =  (this.mergedProps?.className ?? '') + (this.state.isActive ? ' active' : '')

        const attributes = this.getPropertyDifferences (this.mergedProps ?? {}, defaults)

        return (
            (this.props.id) &&
            <button 
                id={`${this.mergedProps?.id}`}
                className={classString}
                type={`${this.mergedProps?.type ?? 'button'}`}
                // riporto gli eventi a cui sono intressato
                onClick={this.onCLickHandler}
                // stampo tutte le altre props
                {...attributes}
            >
                {this.props.children}
            </button>
        )
    }

    onCLickHandler (e: MouseEvent<HTMLButtonElement>) {
        e.stopPropagation()
        
        this.setState({
            isActive: !this.state.isActive
        }, () => {

            if (this.mergedProps?.updateActiveButton && this.state.isActive) {
                this.mergedProps.updateActiveButton(this.mergedProps.id)
            }

            if (this.mergedProps?.onClick) {
                this.mergedProps.onClick(e)
            }
        })
    }
}

export default Button